"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var STORAGE_PARAM_NAME = 'wixTpaSessionStorage:podcasts';
function getStorageState() {
    var rawValue = sessionStorage.getItem(STORAGE_PARAM_NAME);
    if (typeof rawValue === 'string') {
        try {
            return JSON.parse(rawValue);
        }
        catch (err) {
            // do nothing
        }
    }
    return {};
}
function setStorageState(state) {
    sessionStorage.setItem(STORAGE_PARAM_NAME, JSON.stringify(state));
}
function set(key, value) {
    var _a;
    setStorageState(tslib_1.__assign(tslib_1.__assign({}, getStorageState()), (_a = {}, _a[key] = value, _a)));
}
function get(key) {
    var state = getStorageState();
    return (state && state[key]) || null;
}
/**
 * Session Storage for communication between widget and settings.
 * For example share opened widget page between widget and settings.
 */
var tpaSessionStorage = { get: get, set: set };
exports.default = tpaSessionStorage;
//# sourceMappingURL=tpaSessionStorage.js.map